import { render, staticRenderFns } from "./c-content-char-bars@.vue?vue&type=template&id=fd86c788&"
import script from "./c-content-char-bars@.vue?vue&type=script&lang=ts&"
export * from "./c-content-char-bars@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports